import { render, staticRenderFns } from "./BusinessModal.vue?vue&type=template&id=748d7b38&"
import script from "./BusinessModal.vue?vue&type=script&lang=js&"
export * from "./BusinessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports